export default "__VITE_ASSET__3f6fa82a__"